import React, {Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet';

import FrontPage from './containers/FrontPage';
import MenuPage from './containers/MenuPage';
import ContentPage from './containers/ContentPage';
import ContactPage from './containers/ContactPage';
import Header from './containers/Header/Header';
import Footer from './containers/Footer/Footer';
import Cart from './components/Shopify/Cart';

import { shopClient } from './api/shopifyAPI'

import './App.css';

class App extends Component {
  constructor() {
    super();

    this.state = {
      isCartOpen: false,
      checkout: { lineItems: [] }
    };

    this.handleCartToggle = this.handleCartToggle.bind(this);
    this.addVariantToCart = this.addVariantToCart.bind(this);
    this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
    this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
  }

  componentWillMount() {
    shopClient.createCart({}).then((res) => {
      this.setState({
        checkout: res,
      });
    });
  }

  addVariantToCart(variant, quantity){
    this.setState({
      isCartOpen: true,
    });

    const lineItemsToAdd = {variant, quantity: parseInt(quantity, 10)}

    return this.state.checkout.createLineItemsFromVariants(lineItemsToAdd).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  updateQuantityInCart(lineItemId, quantity) {
    return this.state.checkout.updateLineItem(lineItemId, quantity).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  removeLineItemInCart(lineItemId) {
    return this.state.checkout.removeLineItem([lineItemId]).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  handleCartToggle() {
    if(this.state.isCartOpen) {
      this.setState({
        isCartOpen: false
      })
    }
    else {
      this.setState({
        isCartOpen: true
      })
    }
  }

  render() {
    return(
      <div className="app">
        <Helmet
          titleTemplate="%s – Bronda"
          meta={[
            {"property": "og:url", "content": window.location.href},
            {"property": "og:type", "content": "website"},
          ]}
        />
        <Cart
          checkout={this.state.checkout}
          isCartOpen={this.state.isCartOpen}
          handleCartToggle={this.handleCartToggle}
          updateQuantityInCart={this.updateQuantityInCart}
          removeLineItemInCart={this.removeLineItemInCart}
        />
        <Route path="/:slug?" component={Header} />
          <Switch>
            <Route exact path="/" component={FrontPage} />
            <Route path="/menu/:slug/:subslug?" component={MenuPage} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/:slug" component={(props) => <ContentPage {...props} addVariantToCart={this.addVariantToCart}/>} />
          </Switch>
        <Footer/>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js